import FormDrawer from "components/__new/common/form-drawer";
import useLoginInfo from 'hooks/useLoginInfo';


import Maybe from "./Maybe";
import PageContent from "./PageContent";
import TwoFactorAuthConsent from "./TwoFactorAuthConsent";
import TwoFactorPinModal from './TwoFactorPinModal';
import maskEmailAddress from 'utils/maskData';



export const TwoFactorAuthModal = (props) => {
    const {userInfo} = useLoginInfo();
    const {isOpen2fa, setIsOpen2fa, active2fa, setActive2fa, subText, cautionText, show2faContent, setShow2faContent, getEmployerInfo } = props;
    
    const switchModalContent = (value) => { 
        setShow2faContent(value)
     }
    

    const submitForm = async (e) => {
        e.preventDefault();
        
        return props.handleSubmit && props.handleSubmit();
    }
    


    return (
        <div>
        
            <FormDrawer display="center" size="md" isOpen={isOpen2fa} setIsOpen={setIsOpen2fa}>

                <Maybe condition={props.modalLoading === true}>
                    <div className="p-6">
                        <PageContent loading={props.modalLoading} />
                    </div>
                </Maybe>

                <Maybe condition={!props.modalLoading || props.modalLoading === false}>
                    <form onSubmit={submitForm} className="p-6">
                        <div>
                            <div className="text-lg font-bold">
                                {show2faContent === '2faConsent' ? (!active2fa ? 'Two Factor Authentication' : 'Disable Two Factor Authentication') : `Enter OTP`}
                            </div>
                                <div className="text-base text-ep-gray-600">
                                    {show2faContent === '2faConsent' ? 
                                    (!active2fa ? 'Add an extra layer of security to your account' : 'Turn off the extra layer of security to your account') : 
                                    (`Please enter the OTP sent to ${maskEmailAddress(userInfo?.member?.email)} to ${!active2fa ? 'enable two factor authentication' : 'disable two factor authentication'}`)
                                    }
                                </div>
                        </div>
                    {show2faContent === '2faConsent' && 
                    <TwoFactorAuthConsent 
                        switchModalContent={() => switchModalContent('2faPIN')} 
                        setIsOpen2fa={setIsOpen2fa} 
                        subText={subText} 
                        cautionText={cautionText} />}
                    {show2faContent === '2faPIN' && 
                    <TwoFactorPinModal
                        isOpenPin={isOpen2fa}
                        setIsOpenPin={setIsOpen2fa}
                        switchModalContent={switchModalContent}
                        active2fa={active2fa}
                        setActive2fa={setActive2fa}
                        getEmployerInfo={getEmployerInfo}
                    // title="Enter OTP"
                    // description=''
                    // handleSubmit={handleEnable2faSubmit}
                    // handleCancel={handleCancel2faSubmit}
                    // loading={changeTransactionPinLoading}
                    />
                }
                    </form>
                </Maybe>

            </FormDrawer>
        </div>
    )
}

export default TwoFactorAuthModal;
